import Dialog from "@mui/material/Dialog";

export const popUpTypes = {
    ERROR: "ERROR",
    INFO: "INFO",
    INGREDIENT: "INGREDIENT",
    ALT_INGREDIENT: "ALT_INGREDIENT"
}

const PopUpModal = ({ 
  children, open, onClose = () => { }, popUpCategory = "", itemLength = 0
} : {
  children: React.ReactNode, open: boolean, onClose: () => void, popUpCategory: string, itemLength?: number
}) => {

    const popUphandler: any = (category: string) => {
        switch (category) {
            case popUpTypes.ERROR: {
                return { borderRadius: 20, display: 'flex', justifyContent: 'space-between', height: "457px", width: "340px" }
            }
            case popUpTypes.INFO: {
                return { borderRadius: 20, display: 'flex', justifyContent: 'space-between', width: "340px" }
            }
            // case popUpTypes.ALT_INGREDIENT: {
            //     return { borderRadius: 20, padding: 20, display: 'flex', justifyContent: 'space-between', height: "260px", maxWidth: itemLength < 5 && "880px", width: itemLength >= 5 && "880px" }
            // }
            case popUpTypes.INGREDIENT: {
                return { borderRadius: 20, display: 'flex', width: "340px", justifyContent: 'space-between' }
            }
            default: {
                return { borderRadius: 20, display: 'flex', justifyContent: 'space-between', height: "457px", width: "340px" }
            }
        }
    }

    return (<Dialog
        open={open}
        onClose={onClose}
        sx={{ zIndex: 1100 }}
        PaperProps={{
            style: popUphandler(popUpCategory)
        }}
    >
        {children}
    </Dialog>)
}

export default PopUpModal;